import { MenuButton } from "./menu-button.model";
import { PermissionType } from "./permission/permission-type-enum";

export const NavigationItems: MenuButton[] = [
    {
        label: 'menu.home',
        link: 'home',
        icon: 'home',
    },
    {
        label: 'menu.trainingCompetencyMatrix',
        link: 'training-competency-matrix',
        icon: 'grid_view',
    },

    {
        label: 'menu.trainingCompletion',
        link: 'training-completion',
        icon: 'done',
    },
    {
        label: 'menu.reports',
        link: 'reports',
        icon: 'assessment',
        permissions: [PermissionType.AccessReports],
    },
    // {
    //     label: 'menu.trainings',
    //     link: 'help',
    //     icon: 'local_library',
    //     permissions: [PermissionType.AccessTrainings], // TODO: add real perms
    // },
];